import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt'
import { environment } from '../../../environments/environment';
export class TokenApiModel {
    accessToken!: string;
    refreshToken!: string;
}
@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private userPayload: any;

    constructor(private http: HttpClient, private router: Router) {
        this.userPayload = this.decodedToken();
    }

    signUp(userObj: any) {
        const url = `${environment.gateway_url}/registeruser`;
        return this.http.post<any>(url, userObj);
    }

    signIn(username: string, password: string) {
        const loginData = { UserEmail: username, Password: password };
        const url = `${environment.gateway_url}/authenticateuser`;
        return this.http.post(url, loginData);
    }

    signOut() :void{
        localStorage.clear();
        this.router.navigate(['login'])
    }

    storeToken(tokenValue: string) {
        localStorage.setItem('token', tokenValue)
    }


    getToken() {
        return localStorage.getItem('token')
    }


    isLoggedIn(): boolean {
        return !!localStorage.getItem('token')
    }

    decodedToken() {
        const jwtHelper = new JwtHelperService();
        const token = this.getToken()!;
        return jwtHelper.decodeToken(token)
    }

    getfullNameFromToken() {
        if (this.userPayload)
            return this.userPayload.name;
    }
    resetPassword(resetReqObj:any){
        const url = `${environment.gateway_url}/resetuserpassword`;
        return this.http.post<any>(url, resetReqObj);
    }

}
